import SubSequencePage from './SubSequencePage';

export default {
    path: '/link/:path',
    component: SubSequencePage,
};
